import { useQuery } from "@tanstack/react-query";
import { profileApi, MeResponse } from "@/api/profile-api";

export function useMe() {
  const query = useQuery<MeResponse>({
    queryKey: ["me"],
    queryFn: () => profileApi.getMe(),
    staleTime: 5 * 60 * 1000,
  });

  return {
    ...query,
    user: query.data?.user ?? null,
    company: query.data?.company ?? null,
  };
}
